import { FC } from 'react'
import classNames from 'classnames'
import { TextProps } from '@/atoms/Text'
import { Text } from '@/atoms/Text/Text'

interface PifSectionTitleProps {
  children: React.ReactNode
  textProps?: TextProps
  className?: string
}

export const PifSectionTitle: FC<PifSectionTitleProps> = ({ children, textProps, className }) => {
  return (
    <Text
      weight="bold"
      color="black"
      className={classNames('photon-heading-xs md:photon-heading-sm', className)}
      {...textProps}
    >
      {children}
    </Text>
  )
}
